import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
import Hero from './Components/Hero/Hero';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import Chapter6 from './Components/Chapters/Chapter6';
import Chapter7 from './Components/Chapters/Chapter7';
import Chapter8 from './Components/Chapters/Chapter8';
// import PullQuote from './Components/PullQuote/PullQuote';
import EmphasizedParagraph from './Components/EmphasizedParagraph/EmphasizedParagraph';
import contents from './contents';
import RelatedContents from './Components/RelatedContents/RelatedContents';
import CtaButton from './Components/CtaButton/CtaButton';
// import Reference from './Components/Reference/Reference';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const inline5 = useRef();
  const inline6 = useRef();
  const inline7 = useRef();
  const inline8 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4, inline5, inline6, inline7, inline8]; // put all photo refs in this array

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  return (
    <div className="article">
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Chapter1 />

      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[0]} //pass in corresponding data
        photoRef={inline1} //pass in ref
      />
      <Chapter2 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[1]} //pass in corresponding data
        photoRef={inline2} //pass in ref
      />
      <Chapter3 />

      <Chapter4 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[2]} //pass in corresponding data
        photoRef={inline3} //pass in ref
      />

      <Chapter5 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[3]} //pass in corresponding data
        photoRef={inline4}
      />

      <Chapter6 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[4]} //pass in corresponding data
        photoRef={inline5}
      />
      <Chapter7 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[5]} //pass in corresponding data
        photoRef={inline6}
      />
      <Chapter8 />

      <EmphasizedParagraph />
      {/* <PullQuote content={contents.pullQuoteContent.pullQuote1} /> */}
      <CtaButton
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
      />
      {/* <div className="article__divider" /> */}
      {/* <Reference /> */}
      <RelatedContents />
      <Footer />
    </div>
  );
}

export default Article;
